module.exports = __webpack_public_path__ + "img/SKMJ_norunning.24171fdf.jpg";